import React, { useState, useEffect } from 'react';

const CategoryWiseReportPrint = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportParams, setReportParams] = useState({
    from:"",
    branch:"",
    to:"",
    icategory:""
  });

  // Extract parameters from URL or use default values
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {
      from: urlParams.get('from') || '',
      to: urlParams.get('to') || '',
     
      branch: urlParams.get('branch') || '8',
     icategory: urlParams.get('icategory') || '%',
     
    };
    setReportParams(params);
  }, []);

  // Function to call the API
  const fetchReportData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const queryParams = new URLSearchParams(reportParams);
      const response = await fetch(`https://www.nissi-india.com/api/catwise_stockRpt?${queryParams}`);
      console.log("params:",queryParams);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log("response:",data);
      setReportData(data.data);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching report data:', err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when component mounts or parameters change
  useEffect(() => {
    if (reportParams.from && reportParams.to) {
      fetchReportData();
    }
  }, [reportParams]);

  // Calculate total amount
  const totalAmount = reportData.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

  return (
    <div className="max-w-7xl mx-auto p-4 bg-white font-mono text-sm print:p-0 print:max-w-none">
      {/* Header Section */}
      <div className="border-2 border-black mb-0">
        <div className="border-b border-black flex">
          {/* Logo Section */}
          <div className="w-32 border-r border-black p-2 flex items-center justify-center">
            <div className="bg-black text-white px-2 py-1 text-xs font-bold text-center">
              <div>NISSI</div>
              <div>INFOTECH PVT LTD</div>
            </div>
          </div>
          
          {/* Company Info Section */}
          <div className="flex-1 p-3">
            <div className="text-center">
              <h1 className="text-lg font-bold mb-1">Nissi Infotech</h1>
              <div className="text-xs">
                <div>Nissi</div>
                <div className="font-bold">CIVIL CONSTRUCTION</div>
                <div>3/42-12, Nagappa colony , kavundampalayam,641600 ,Tamil Nadu , India .</div>
                <div>Phone No :9003744644 infraconsoft-implementation@nissi</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Report Title */}
        <div className="text-center py-2 border-b border-black font-bold">
          Category Wise Stock Report
        </div>
        
        {/* Date Range */}
        <div className="px-3 py-1 text-xs">
          <span>From Date: {reportParams.from}</span>
          <span className="ml-3">TO Date:{reportParams.to}</span>
          <span className="ml-8">Branch: {reportParams.branch}</span>
        </div>
      </div>

      {/* Loading/Error States */}
      {loading && (
        <div className="text-center py-4">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-black"></div>
          <div className="mt-2">Loading report data...</div>
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
          <div className="font-bold">Error loading report:</div>
          <div>{error}</div>
          <button 
            onClick={fetchReportData}
            className="mt-2 bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700"
          >
            Retry
          </button>
        </div>
      )}

      {/* Table Section */}
     <div className="border-l-2 border-r-2 border-b-2 border-black">
  <table className="w-full text-xs">
    <thead>
      <tr className="border-b border-black">
        <th className="border-r border-black px-2 py-1 w-12">S.No</th>
        <th className="border-r border-black px-2 py-1 w-20">Category Code</th>
        <th className="border-r border-black px-2 py-1 w-20">Category Name</th>
        <th className="border-r border-black px-2 py-1 w-24">Amount</th>
      </tr>
    </thead>
    <tbody>
      {!loading && reportData.length === 0 ? (
        <tr>
          <td colSpan="4" className="p-4 text-center text-gray-500">
            No data available for the selected criteria
          </td>
        </tr>
      ) : (
        reportData.map((item, index) => (
          <tr key={index} className="border-b border-gray-300">
            <td className="border-r border-black px-2 py-1 text-center">{index + 1}</td>
            <td className="border-r border-black px-2 py-1">{item.Code || ""}</td>
            <td className="border-r border-black px-2 py-1">{item.Category || ""}</td>
            <td className="border-r border-black px-2 py-1 text-right">
              {Number(item.Amount || 0).toFixed(2)}
            </td>
          </tr>
        ))
      )}

      {/* Total Row */}
      <tr className="border-t-2 border-black font-bold">
        <td colSpan="3" className="border-r border-black px-2 py-1 text-right">
          Total Rs :
        </td>
        <td className="px-2 py-1 text-right">
          {reportData
            .reduce((sum, item) => sum + Number(item.Amount || 0), 0)
            .toFixed(2)}
        </td>
      </tr>
    </tbody>
  </table>
</div>


      {/* Footer */}
      <div className="mt-4 text-xs text-gray-600 border border-gray-300 p-2 bg-gray-50">
        Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com
      </div>

      {/* Parameter Display (for debugging) */}
      

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          body { margin: 0; }
          .print\\:hidden { display: none !important; }
          .print\\:p-0 { padding: 0 !important; }
          .print\\:max-w-none { max-width: none !important; }
        }
      `}</style>
    </div>
  );
};

export default CategoryWiseReportPrint;